import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined, Edit, FilterList, Info } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FloatingAlert from "components/FloatingAlert";
import {
  resetDetailSetoranHarian,
  resetPengeluaranSetoran,
  setMessage,
  setStatus,
} from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import {
  fetchChangeStatusSetoran,
  fetchDeleteSetoran,
  fetchEditCatatanSetoran,
  fetchListSetoran,
  fetchOptionsSetoran,
  fetchDetailSetoranPerhari,
  fetchPengeluaranSetoran,
  fetchGetPengeluaranSetoran,
  fetchGetPengeluaranSetoranGlobal,
  fetchSaveWarkat,
} from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import DetailSetoranModal from "components/Modals/DetailSetoranModal";
import EditCatatanModal from "components/Modals/EditCatatanModal";
import DetailSetoranHarianModal from "components/Modals/DetailSetoranHarianModal";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
import DetailSetoranModalTransfer from "components/Modals/DetailSetoranModalTransfer";
import {
  fetchListPerkiraan,
  postListTransaksiWarkat,
} from "state/alokasiAction";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/id";
moment.locale("id");

const Setoran = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, message } = useSelector((state) => state.global);
  const {
    list_setoran,
    pagination_setoran,
    options_setoran,
    detail_setoran_harian,
    pengeluaran_setoran,
    pengeluaran_setoran_global,
  } = useSelector((state) => state.setoran);
  const { list_perkiraan } = useSelector((state) => state.alokasi);

  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailTransfer, setOpenDetailTransfer] = useState(false);
  const [openEditCatatan, setOpenEditCatatan] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [showingDetail, setShowingDetail] = useState(false);

  const [cabangDataFromDetail, setCabangDataFromDetail] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const queryParams = useMemo(() => {
    const p = { page: page + 1, limit: rowsPerPage };
    const f = appliedFilters;
    if (f.dateRange?.tanggalAwal) p.tanggal_awal = f.dateRange.tanggalAwal;
    if (f.dateRange?.tanggalAkhir) p.tanggal_akhir = f.dateRange.tanggalAkhir;
    if (f.filter?.nama_cab?.length) p.nama_cab = f.filter.nama_cab.join(",");
    if (f.filter?.nama_karyawan?.length)
      p.nama_karyawan = f.filter.nama_karyawan.join(",");
    if (f.filter?.status) p.status = f.filter.status;
    if (f.sort?.length) {
      const sortStr = f.sort
        .filter((s) => s.column)
        .map((s) => `${s.column}:${s.order}`)
        .join(",");
      if (sortStr) p.sort = sortStr;
    }
    return p;
  }, [page, rowsPerPage, appliedFilters]);

  useEffect(() => {
    dispatch(fetchListSetoran(queryParams));
  }, [dispatch, queryParams]);

  useEffect(() => {
    dispatch(fetchListPerkiraan());
    dispatch(fetchOptionsSetoran());
  }, [dispatch]);

  const handleApplyCustomFilter = (filters) => {
    setPage(0);
    setAppliedFilters(filters);
  };

  const handleClearCustomFilter = () => {
    setPage(0);
    setAppliedFilters({});
  };

  const getActiveFilterCount = useCallback(() => {
    let count = 0;

    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    if (appliedFilters.filter) {
      if (appliedFilters.filter.nama_cab?.length > 0) count++;
      if (appliedFilters.filter.nama_karyawan?.length > 0) count++;
      if (appliedFilters.filter.status?.length > 0) count++;
    }

    return count;
  }, [appliedFilters]);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran(queryParams));
    setIsDelete(false);
  };

  const handleSelectedData = useCallback(
    (id) => {
      let currentSelectedData = list_setoran.find((item) => item.id === id);
      setSelectedData(currentSelectedData);
      dispatch(fetchGetPengeluaranSetoran(currentSelectedData));
    },
    [list_setoran, dispatch],
  );

  const handleSetujui = () => {
    dispatch(fetchChangeStatusSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleDelete = () => {
    dispatch(fetchDeleteSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleSubmitEditKaryawan = (value) => {
    dispatch(fetchEditCatatanSetoran(selectedData.id, value));
    setOpenEditCatatan(false);
    setSelectedData(null);
  };

  const formatStringToArrayPengeluaran = (
    inputString,
    tanggalAlokasi,
    tanggalSetoran,
  ) => {
    if (!inputString) return [];

    return inputString.split(";").map((item, index) => ({
      id: Date.now() + index,
      nama: item.split(":")[0].trim(),
      nominal: parseInt(item.split(":")[1].trim(), 10),
      kode_perkiraan: null,
      tipe: "pengeluaran",
      status: "alokasi",
      catatan: "Pengeluaran Setoran - " + item.split(":")[0].trim(),
      tanggal_kas: moment(tanggalAlokasi).format(),
      tanggal_setoran: moment(tanggalSetoran).format(),
    }));
  };

  const handleSaveWarkat = async (value) => {
    try {
      if (pengeluaran_setoran_global?.list_pengeluaran) {
        const pengeluaranToAlokasi = formatStringToArrayPengeluaran(
          pengeluaran_setoran_global.list_pengeluaran,
          value.tanggal_kas,
          value.tanggal_setoran,
        );

        await dispatch(postListTransaksiWarkat(pengeluaranToAlokasi));
      }

      await dispatch(fetchSaveWarkat(value));

      setShowingDetail(false);
      setSelectedData(null);

      setTimeout(() => {
        navigate("/alokasidc");
      }, 3000);
    } catch (error) {
      console.error("Error saving warkat:", error);
      alert("Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
    }
  };

  const handleSubmitPengeluaran = (value, justApprove) => {
    if (!!justApprove) {
      handleSetujui();
    } else {
      if (!value.id) {
        handleSetujui();
      }
      dispatch(fetchPengeluaranSetoran(value));
    }
    setOpenDetail(false);
    setOpenDetailTransfer(false);
  };
  const renderStatusSetoran = (value) => {
    if (value == "disetujui") {
      return "Disetujui";
    } else {
      return "Belum Disetujui";
    }
  };

  const handleGetSetoranPecabangSelected = (tgl_kas, waktu_setoran) => {
    if (!list_setoran || !tgl_kas || !waktu_setoran) return;

    const filtered = list_setoran.filter((item) => {
      if (!item.tgl_kas || !item.waktu_setoran) return false;
      const isSameTglKas = moment(item.tgl_kas).isSame(moment(tgl_kas), "day");
      const isDisetujui = item.status?.toLowerCase() === "disetujui";
      return isSameTglKas && isDisetujui;
    });

    setCabangDataFromDetail(filtered);
  };

  const columnsSetoran = useMemo(
    () => [
      {
        name: "id",
        label: "ID",
        options: {
          display: false,
        },
      },
      {
        name: "nama_cab",
        label: "Setoran Toko",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "tgl_kas",
        label: "Waktu Sinkron",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const waktuSetoran = tableMeta.rowData[3];
            return (
              <a
                style={{ cursor: "pointer", color: "red" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleGetSetoranPecabangSelected(value, waktuSetoran);
                  dispatch(fetchDetailSetoranPerhari(value, waktuSetoran));
                  dispatch(fetchGetPengeluaranSetoranGlobal(value));
                  setShowingDetail(true);
                }}
              >
                {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
              </a>
            );
          },
        },
      },
      {
        name: "waktu_setoran",
        label: "Waktu Setoran",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const tglKas = tableMeta.rowData[2];
            return (
              <a
                style={{ cursor: "pointer", color: "red" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleGetSetoranPecabangSelected(tglKas, value);
                  dispatch(fetchDetailSetoranPerhari(tglKas, value));
                  dispatch(fetchGetPengeluaranSetoranGlobal(tglKas));
                  setShowingDetail(true);
                }}
              >
                {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
              </a>
            );
          },
        },
      },
      {
        name: "nominal_setoran",
        label: "Nominal Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => formatRupiah(value),
        },
      },
      {
        name: "nama_karyawan",
        label: "Nama Penyetor",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "status",
        label: "Status Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => renderStatusSetoran(value),
        },
      },
      {
        name: "transfer",
        label: "Transfer",
        options: {
          display: false,
        },
      },
      {
        name: "tipe",
        label: "Tipe Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),

          customBodyRender: (value, tableMeta, updateValue) => {
            const transfer = tableMeta.rowData[7];
            if (transfer > 0) {
              return "Transfer";
            } else {
              return "Tunai";
            }
          },
        },
      },
      {
        name: "catatan",
        label: "Catatan Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => value || "-",
        },
      },
      {
        name: "aksi",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0];
            const transfer = tableMeta.rowData[7];
            return (
              <>
                <IconButton
                  color="info"
                  onClick={() => {
                    handleSelectedData(id);
                    if (transfer > 0) {
                      setOpenDetailTransfer(true);
                    } else {
                      setOpenDetail(true);
                    }
                  }}
                >
                  <Info />
                </IconButton>
                <IconButton
                  color="info"
                  onClick={() => {
                    handleSelectedData(id);
                    setOpenEditCatatan(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  color="warning"
                  onClick={() => {
                    handleSelectedData(id);
                    setIsDelete(true);
                    setOpenKonfirmasi(true);
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </>
            );
          },
        },
      },
    ],
    [dispatch, handleSelectedData],
  );

  const options = useMemo(
    () => ({
      selectableRows: "none",
      filterType: "dropdown",
      filter: false,
      fixedHeader: false,
      fixedSelectColumn: false,
      search: true,
      viewColumns: false,
      responsive: "standard",
      customToolbar: () => {
        const activeCount = getActiveFilterCount();
        return (
          <Button
            startIcon={<FilterList />}
            onClick={() => setOpenCustomFilter(true)}
            variant={activeCount > 0 ? "contained" : "outlined"}
            size="small"
            color={activeCount > 0 ? "primary" : "inherit"}
            sx={{
              mr: 1,
              ...(activeCount === 0 && {
                color: "text.secondary",
                borderColor: "text.secondary",
              }),
            }}
          >
            Filter {activeCount > 0 && `(${activeCount})`}
          </Button>
        );
      },
      rowsPerPageOptions: [25, 50, 75],
      rowsPerPage: rowsPerPage,
      serverSide: true,
      count: pagination_setoran?.total ?? 0,
      page: page,
      onChangePage: (currentPage) => setPage(currentPage),
      onChangeRowsPerPage: (numberOfRows) => {
        setRowsPerPage(numberOfRows);
        setPage(0);
      },
    }),
    [page, rowsPerPage, pagination_setoran, getActiveFilterCount],
  );

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Setoran" subtitle="Daftar Setoran dari setiap toko." />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_setoran}
          columns={columnsSetoran}
          options={options}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={isDelete ? "Hapus" : "Setujui"}
          subtitleType={isDelete ? "Menghapus" : "Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => (isDelete ? handleDelete() : handleSetujui())}
          textButtonPositif={isDelete ? "Hapus" : "Setujui"}
        />
        <EditCatatanModal
          open={openEditCatatan}
          dataEdit={selectedData}
          onClose={() => setOpenEditCatatan(false)}
          onSubmit={(value) => handleSubmitEditKaryawan(value)}
        />
        <DetailSetoranModal
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          listPerkiraan={list_perkiraan}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranModalTransfer
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          open={openDetailTransfer}
          onClose={() => {
            setSelectedData(null);
            setOpenDetailTransfer(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranHarianModal
          dataDetail={detail_setoran_harian}
          dataPengeluaran={pengeluaran_setoran_global}
          open={showingDetail && detail_setoran_harian}
          onClose={() => {
            dispatch(resetDetailSetoranHarian());
            dispatch(resetPengeluaranSetoran());
            setShowingDetail(false);
            setCabangDataFromDetail([]);
          }}
          onSaveWarkat={handleSaveWarkat}
          listCabang={cabangDataFromDetail}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_setoran}
          cabangOptions={options_setoran?.nama_cab ?? null}
          karyawanOptions={options_setoran?.nama_karyawan ?? null}
        />
      </Box>
    </Box>
  );
};

export default Setoran;
